import * as React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import type { AuthorizedParcel } from '@dpdgroupuk/fmx-ui/types/Parcel';
import useStyles from '../styles';
import RobotDeliverySteps from '../../../../../components/RobotDeliverySteps';

type Props = {
  parcel: AuthorizedParcel,
};

const OutForDeliveryRobotDesktopView = ({ parcel }: Props) => {
  const bottomComponentRef = React.useRef({});
  const styles = useStyles({
    footerHeight: bottomComponentRef.current.clientHeight,
  });

  const {
    robotName,
    eta,
    currentDeliveryNumber,
    deliveryNumber,
  } = parcel.parcelStatusInfo;

  return (
    <div className={styles.wrapper}>
      <Grid
        container
        direction="column"
        justify="space-around"
        alignItems="center"
        className={styles.container}
        ref={bottomComponentRef}
      >
        <div className={clsx(styles.titleContainer, styles.marginBottom)}>
          <Typography className={styles.deliveryInfo}>
            Your order will be delivered by{' '}
            <span className={styles.redText}>{robotName}</span>, your DPD robot,
            <br />
            <span className={styles.redText}>{eta}</span>
          </Typography>
        </div>

        <div className={clsx(styles.titleContainer, styles.marginBottom)}>
          <Typography className={styles.deliveryInfo}>
            {robotName} is currently making delivery number{' '}
            <span className={styles.redText}>{currentDeliveryNumber}</span>, you
            are delivery number <br />
            <span className={styles.redText}>{deliveryNumber}</span>
          </Typography>
        </div>
        <RobotDeliverySteps robotName={robotName} />
        <Grid container direction="row" className={styles.logoWithETAContainer}>
          <Grid
            container
            direction="column"
            justify="space-around"
            className={styles.progressContainer}
          >
            <Grid item className={styles.bottomLine} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default OutForDeliveryRobotDesktopView;
